export default __webpack_public_path__ + "static/media/report_08.cfd3c8e9.png";